
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import {
  getCardAccountList,
  addCardAccount,
  deleteCardAccount
} from '@/api/product/cardAccount'
import { Form as ElForm } from 'element-ui'
import addCard from './cardComponents/add.vue'
import editCard from './cardComponents/edit.vue'
import { PermissionModule } from '@/store/modules/permission'

@Component({
  name: 'cardAccount',
  components: {
    addCard,
    editCard
  }
})
export default class extends Vue {
  private manager: string = PermissionModule.manager
  private queryForm: any = {
    name: ''
  }
  private list: any[] = []
  private total = 0
  private listLoading: boolean = false

  private addVisible: boolean = false
  private addCardAccount() {
    this.addVisible = true
  }
  private closeAdd() {
    this.addVisible = false
    this.hadleGetFilesListApi()
  }

  private editInfo: any = {}
  private editVisible: boolean = false
  private editCardAccount(row) {
    this.editInfo = row
    this.editVisible = true
  }
  private closeEdit() {
    this.editVisible = false
    this.hadleGetFilesListApi()
  }

  private delAccount(row: any) {
    this.$confirm('是否删除该账户?', '').then(() => {
      // 删除
      const data = {
        id: row.id
      }
      deleteCardAccount(data).then((res: any) => {
        this.hadleGetFilesListApi()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    })
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getCardAccountList(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      name: ''
    }
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }
  private sysType: any = ''
  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''
  mounted() {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.cardAccount`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.cardAccount`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
